import figlet from 'figlet';
import bigMoneyModule from 'figlet/importable-fonts/Big Money-ne';

const FONT_NAME = 'Big Money-ne';
const bigMoney = bigMoneyModule.default ?? bigMoneyModule;

figlet.parseFont(FONT_NAME, bigMoney);

const raw = figlet.textSync('BASS', { font: FONT_NAME });

export default raw.replace(/\n[\s\n]*$/, '');
